import React, { FC, useState } from 'react';
import useTranslations from '@hooks/useTranslations';
import Collapsible from 'react-collapsible';
import Icon, { Icons } from '@components/Icon';
import { BasketPxDetailsProps } from '@components/BasketPxDetails';
import { faqsTemplateId } from '@components/FAQs';
import PartExchangeWidget from '@components/PartExchange/PartExchangeWidget';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { AccessibleButton } from '@components/Button/AccessibleButton';
import { useGetNotEscapedTranslationMarkup } from '@hooks/useGetNotEscapedTranslationMarkup';
import { Link } from '@components/v2/link';
import DealerPartExchange from '@components/DealerPartExchange';
import { usePersonalizedOffer } from '@hooks/usePersonalizedOffer';
import { useUserDuck } from '@hooks/useUserDuck';

const BasketPxDetailsTemplate: FC<BasketPxDetailsProps> = ({ className, generatedIndex }) => {
    const { t } = useTranslations();

    const { getNotEscapedTranslationMarkup } = useGetNotEscapedTranslationMarkup();

    const { isUserLoggedInAsDealer } = useUserDuck();

    const { isPersonalizedDeal } = usePersonalizedOffer();

    const { hasPersonalizedPx } = usePersonalizedOffer();

    const [isOpen, setIsOpen] = useState(true);
    const { currentDeal, carDetails } = useCarDetailsDuck();
    const scrollToFAQs = () => {
        const element = document.getElementById(faqsTemplateId);

        return element.scrollIntoView();
    };

    return (
        <div className={className} id="px">
            <Collapsible
                lazyRender={true}
                open={isOpen}
                trigger={
                    <AccessibleButton className="titleWrapperButton" onClick={() => setIsOpen(!isOpen)}>
                        <div className="titleWrapper">
                            <div className="titleContainer">
                                <span className="sectionNumber">{generatedIndex}.</span>
                                <span className="title">{`${t(`basket.px.title${isUserLoggedInAsDealer || hasPersonalizedPx ? '.dealer' : ''}`).toLowerCase()}`}</span>
                            </div>
                            <Icon
                                className={isOpen ? 'isOpen' : 'isClose'}
                                name={isOpen ? Icons.ChevronUp : Icons.ChevronDown}
                            />
                        </div>
                    </AccessibleButton>
                }
            >
                <div className="description">
                    <span
                        dangerouslySetInnerHTML={getNotEscapedTranslationMarkup(
                            `basket.px.description${isUserLoggedInAsDealer ? '.dealer' : ''}${
                                isPersonalizedDeal ? '.personalizedOffer' : ''
                            }`
                        )}
                    />
                    <Link
                        withParent={false}
                        isUnderline
                        txt={t(
                            `basket.px.description.text${isUserLoggedInAsDealer ? '.dealer' : ''}${
                                isPersonalizedDeal ? '.personalizedOffer' : ''
                            }`
                        )}
                        onClick={scrollToFAQs}
                    >
                        <button className="link" onClick={scrollToFAQs}>
                            {t(
                                `basket.px.description.text${isUserLoggedInAsDealer ? '.dealer' : ''}${
                                    isPersonalizedDeal ? '.personalizedOffer' : ''
                                }`
                            )}
                        </button>
                    </Link>
                </div>
                {hasPersonalizedPx || isUserLoggedInAsDealer ? (
                    <DealerPartExchange />
                ) : (
                    <PartExchangeWidget selectionMode car={carDetails} mopId={currentDeal?.mopId} />
                )}
            </Collapsible>
        </div>
    );
};

export default BasketPxDetailsTemplate;
